import { Flex, Typography } from 'antd';
import type { CSSProperties, FC } from 'react';
import classNames from 'classnames';

interface AvatarProfileProps {
  label: string;
  containerStyles?: CSSProperties;
  textStyles?: CSSProperties;
  containerClassName?: string;
  textClassName?: string;
}

export const AvatarProfile: FC<AvatarProfileProps> = ({
  label,
  containerStyles = {
    width: '32px',
    height: '32px',
    background: '#ED131C',
    borderRadius: '50%',
  },
  textStyles = {
    color: '#FFFFFF',
    fontWeight: 500,
    fontSize: '22px',
  },
  containerClassName,
  textClassName,
}) => {
  const { Text } = Typography;

  return (
    <Flex align="center" justify="center" style={containerStyles} className={containerClassName}>
      <Text style={textStyles} className={classNames('noselect', textClassName)}>
        {label}
      </Text>
    </Flex>
  );
};
